const initialState = {
	markets: null,
	loading: false,
	error: null,
	selectedMarket: {
		_id: '',
		updatedAt: '',
		createdAt: '',
		longitude: '',
		latitude: '',
		time_zone: '',
		state: '',
		city: '',
		start_date: '',
		operational_unit: '',
		phone_number: '',
		services: [],
		phase: '',
		basic_member_promo_text: '',
		header_text: '',
		sub_header_text: '',
		pre_launch_benefits_list: [],
		available_membership_types: []
	}
}

const markets = (state = initialState, action) => {
	switch (action.type) {
		case 'SET_MARKET': {
			return {
				...state,
				markets: state.markets.map((m) => {
					if (m._id === action.payload._id) {
						return { ...action.payload }
					}

					return m
				}),
				selectedMarket: {
					...state.selectedMarket,
					...action.payload
				}
			}
		}
		case 'RESET_APP':
			return { ...initialState }
		case 'CLEAR_VETS':
			return { ...state, markets: null, loading: false, error: null }
		case 'GET_MARKETS':
			return { ...state, loading: true, error: null }
		case 'GET_MARKETS_SUCCESS':
			return { ...state, markets: action.payload, loading: false, error: null }
		case 'GET_MARKETS_FAIL':
			return { ...state, loading: false, error: action.payload }
		default:
			return state
	}
}

export default markets
